<template>
    <a-card>
        <a-radio-group v-model:value="large">
            <a-radio-button :class="{radioClass:active=='服务机构'}" @click="onSellerCancel('4')" value="large">服务机构</a-radio-button>
            <a-radio-button :class="{radioClass:active=='课程'}" @click="onSellerCancel('6')" value="default">课程</a-radio-button>
            <a-radio-button :class="{radioClass:active=='运营内容'}" @click="onSellerCancel('7')" value="small">运营内容</a-radio-button>
          </a-radio-group>
        <a-table
            :columns="columns"
            :pagination="pagination"
            :data-source="dataSources"
            :loading="loading"
            @change="onTableChange">
            <!-- <template #index="{index}">{{ index + 1 }}</template> -->
            <template #titles="{ record }">
               <a :href="record.url">{{ record.title }}</a>
            </template>
            <template #type="{text}">
                <a-tag>
                    <dict-render :dict-obj="dictObjs['collecttype']" :text="text"></dict-render>
                </a-tag>
            </template>
        </a-table>
    </a-card>
</template>

<script>
import {collectApi} from "@/api/innovationService";
import {tableListMixin,dictMixin} from "@/mixins";
import DictRender from "@/components/other/DictRender";
import {defaultDateCustomRender} from "@/utils/customRender";

const columns = [
    // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
    {title: "收藏标题", dataIndex: "title", key: "title",slots:{customRender: "titles"}},
    {title: "收藏时间", dataIndex: "createdTime", key: "createdTime", customRender: defaultDateCustomRender},
    {title: "收藏类型", dataIndex: "type", key: "type",slots:{customRender: "type"}},
    {title: "操作", dataIndex: "action", key: "action", slots: {customRender: "action"}},

];
export default {
    name: "index",
    mixins: [tableListMixin,dictMixin],
    components: {
        DictRender
    },
    data() {
        return {
            active:'机构',
            dictNames: 'collecttype',
            columns,
            listKeyField: "id",
            dataSources: null,
        }
    },
    mounted() {
        this.onSellerCancel('4')
    },
    methods: {
        onSellerCancel(num) {
            this.getAction({
                url: collectApi.pageList,
                params: {
                    systemType:'knowledge',
                    pageNum: 1,
                    pageSize: 10,
                    type:num
                }
            }).then(res => {
                if(num=='4'){
                    this.active='服务机构'
                }else if(num=='6'){
                    this.active='课程'
                }else if(num=='7'){
                    this.active='运营内容'
                }
                console.log(res)
                this.dataSources = res.records
            })
        },
    }
}
</script>

<style scoped>
.radioClass{
    background: #1890ff;
    color:#fff;
    margin-bottom: 20px;
}
</style>
